import { useState, useEffect } from "react";
import { AdminField, AdminSaveButton, AdminSection } from "@/admin/AdminComponents";

const HeroEditor = ({ data, onSave, saving }) => {
  const [form, setForm] = useState({});

  useEffect(() => { setForm({ ...data }); }, [data]);

  const update = (key, val) => setForm((p) => ({ ...p, [key]: val }));
  const updateCta = (which, key, val) =>
    setForm((p) => ({ ...p, [which]: { ...p[which], [key]: val } }));

  return (
    <div data-testid="hero-editor">
      <AdminSection title="Hero Content" description="Main headline area of the landing page">
        <AdminField label="Top Label" value={form.label} onChange={(v) => update("label", v)} placeholder="Software · Automation · Communication" />
        <AdminField label="Headline" value={form.headline} onChange={(v) => update("headline", v)} placeholder="Mayr Technologies" />
        <AdminField label="Subheadline" value={form.subheadline} onChange={(v) => update("subheadline", v)} rows={2} placeholder="We build modern software..." />
      </AdminSection>

      <AdminSection title="Call to Action Buttons">
        <div className="grid grid-cols-2 gap-4">
          <AdminField label="Primary Button Text" value={form.primary_cta?.text} onChange={(v) => updateCta("primary_cta", "text", v)} />
          <AdminField label="Primary Button Link" value={form.primary_cta?.href} onChange={(v) => updateCta("primary_cta", "href", v)} />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <AdminField label="Secondary Button Text" value={form.secondary_cta?.text} onChange={(v) => updateCta("secondary_cta", "text", v)} />
          <AdminField label="Secondary Button Link" value={form.secondary_cta?.href} onChange={(v) => updateCta("secondary_cta", "href", v)} />
        </div>
      </AdminSection>

      <AdminSaveButton onClick={() => onSave(form)} saving={saving} />
    </div>
  );
};

export default HeroEditor;
